// Dialog "Aggiungi Materiale da Catalogo" del dettaglio preventivo PV
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Input } from '../ui/input';
import {
    Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '../ui/dialog';
import {
    Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { MagnifyingGlass, Package, Sun, Lightning, BatteryFull, Cube, Check, Plus } from '@phosphor-icons/react';
import { formatCurrency } from '../../lib/format';

const MATERIAL_CATEGORIES = {
    'MODULI': { label: 'Moduli FV', icon: Sun, color: 'bg-amber-100 text-amber-700' },
    'INVERTER': { label: 'Inverter', icon: Lightning, color: 'bg-blue-100 text-blue-700' },
    'INVERTER_IBRIDO': { label: 'Inverter Ibrido', icon: Lightning, color: 'bg-indigo-100 text-indigo-700' },
    'STORAGE': { label: 'Batterie', icon: BatteryFull, color: 'bg-green-100 text-green-700' },
    'OTTIMIZZATORI': { label: 'Ottimizzatori', icon: Cube, color: 'bg-purple-100 text-purple-700' },
};

export const QuoteAddMaterialDialog = ({
    open, onOpenChange, quote,
    catalogSearch, setCatalogSearch,
    catalogTypeFilter, setCatalogTypeFilter,
    catalogBrandFilter, setCatalogBrandFilter,
    catalogBrands, catalogItems, loadingCatalog,
    onAddItem,
}) => (
    <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-hidden flex flex-col">
            <DialogHeader>
                <DialogTitle>Aggiungi Materiale da Catalogo</DialogTitle>
                <DialogDescription>Seleziona i componenti dal listino materiali</DialogDescription>
            </DialogHeader>
            
            {/* Filters */}
            <div className="flex flex-col sm:flex-row gap-3 py-4 border-b">
                <div className="relative flex-1">
                    <MagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-400" />
                    <Input
                        placeholder="Cerca..."
                        value={catalogSearch}
                        onChange={(e) => setCatalogSearch(e.target.value)}
                        className="pl-9"
                    />
                </div>
                <Select value={catalogTypeFilter} onValueChange={setCatalogTypeFilter}>
                    <SelectTrigger className="w-40">
                        <SelectValue placeholder="Tipo" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="all">Tutti i tipi</SelectItem>
                        <SelectItem value="MODULI">Moduli</SelectItem>
                        <SelectItem value="INVERTER,INVERTER_IBRIDO">Inverter</SelectItem>
                        <SelectItem value="STORAGE">Batterie</SelectItem>
                        <SelectItem value="OTTIMIZZATORI">Ottimizzatori</SelectItem>
                    </SelectContent>
                </Select>
                <Select value={catalogBrandFilter} onValueChange={setCatalogBrandFilter}>
                    <SelectTrigger className="w-40">
                        <SelectValue placeholder="Marca" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="all">Tutte le marche</SelectItem>
                        {catalogBrands.map((b) => (
                            <SelectItem key={b} value={b}>{b}</SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>

            {/* Items List */}
            <div className="flex-1 overflow-y-auto py-2 space-y-2">
                {loadingCatalog ? (
                    <div className="flex items-center justify-center py-12">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                    </div>
                ) : catalogItems.length === 0 ? (
                    <p className="text-center py-12 text-zinc-500">Nessun prodotto trovato</p>
                ) : (
                    catalogItems.map((item) => {
                        const category = MATERIAL_CATEGORIES[item.type_code] || {};
                        const CategoryIcon = category.icon || Package;
                        const isAdded = quote.lines?.some(l => l.catalog_item_id === item.id);
                        
                        return (
                            <div 
                                key={item.id}
                                className={`flex items-center gap-4 p-3 border rounded-lg hover:bg-zinc-50 cursor-pointer transition-colors ${isAdded ? 'bg-green-50 border-green-200' : ''}`}
                                onClick={() => !isAdded && onAddItem(item)}
                            >
                                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${category.color || 'bg-zinc-100'}`}>
                                    <CategoryIcon className="w-5 h-5" />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2">
                                        <span className="text-xs font-bold text-zinc-500">{item.brand}</span>
                                        <Badge variant="outline" className="text-xs">{category.label || item.type_code}</Badge>
                                    </div>
                                    <p className="font-medium truncate">{item.model}</p>
                                    {item.technical_specs?.pmax_w && (
                                        <p className="text-xs text-zinc-500">{item.technical_specs.pmax_w}W</p>
                                    )}
                                    {item.technical_specs?.potenza_nominale_ac_kw && (
                                        <p className="text-xs text-zinc-500">{item.technical_specs.potenza_nominale_ac_kw} kW</p>
                                    )}
                                </div>
                                <div className="text-right">
                                    <p className="font-bold">{formatCurrency(item.prezzo_listino)}</p>
                                    {isAdded ? (
                                        <Badge className="bg-green-100 text-green-700">
                                            <Check className="w-3 h-3 mr-1" />
                                            Aggiunto
                                        </Badge>
                                    ) : (
                                        <Button size="sm" variant="outline" className="mt-1">
                                            <Plus className="w-4 h-4 mr-1" />
                                            Aggiungi
                                        </Button>
                                    )}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>

            <DialogFooter>
                <Button variant="outline" onClick={() => onOpenChange(false)}>
                    Chiudi
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
);
